import styled, { css } from 'styled-components';

import { LS_THEME_NON_AUTHORIZED, TLangSwitcherProps } from './lang-switcher';

const nonAuthorizedTheme = css`
  min-width: 100px;
  position: absolute;
  top: 16px;
  right: 18px;
`;

const authorizedTheme = css`
  min-width: 100px;
  /* margin-top: 14px; */
`;

export default styled.div<{ variant?: any }>`
  ${(props) => {
    if (props.variant === LS_THEME_NON_AUTHORIZED) {
      return nonAuthorizedTheme;
    }
    return authorizedTheme;
  }}
`;
